import { AdminContainer } from '@/components/containers/containers.component';
import { EditCustomerForm } from '@/components/forms/edit-customer.form.component';
import { cn } from '@/lib/utils';
import { IfPermitted, UserPermissions } from '@/modules/Permissions';

export default function EditCustomer() {
  return (
    <IfPermitted permissions={[UserPermissions.CUSTOMER_LIST]}>
      <AdminContainer className={cn('flex flex-col')} title="Edit Customer">
        <EditCustomerForm />
      </AdminContainer>
    </IfPermitted>
  );
}
